import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { ButtonSubmit } from '@app/components';
import Icon from '@app/components/Icon/index';

interface IReceivedData {
    isOnboardingCompleting: boolean;
    summaryCallback: Function;
}

const OnboardSummaryComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const summaryClicked = () => {
        props.summaryCallback();
    };

    return (
        <>
            <div className='onboard--content'>
                <Icon icon='verification2FaSuccessIco' className='manage-mfa-token__icon' />
                <h1>{translation('MFA_VERIFICATION_SUCCESS_TITLE')}</h1>
                <p className='manage-mfa-token__description'>{translation('MFA_VERIFICATION_SUCCESS_DESCRIPTION')}</p>
                <div className='onboard__buttons'>
                    <ButtonSubmit
                        isLoad={props.isOnboardingCompleting}
                        buttonText={translation('DONE')}
                        className='onboard__button--submit'
                        onClick={summaryClicked}
                        isDisabled={props.isOnboardingCompleting}
                        id='summaryButton'
                    />
                </div>
            </div>
        </>
    );
};

export default OnboardSummaryComponent;
